import ResponsiveHoc from '../../../../components/ResponsiveHoc';

import MobileNotificationSetting from './mobile';
import DesktopNotificationSetting from './desktop';
export default ResponsiveHoc({ xs: MobileNotificationSetting, sm: DesktopNotificationSetting });
